import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

/**
 * Holds the currently-open prospect key so the single shared prospect modal can be
 * opened from any prospecting view (map, table, board).
 */
@Injectable({ providedIn: 'root' })
export class ProspectModalService {
    private openKeySubject = new BehaviorSubject<string | null>(null)
    readonly openKey$ = this.openKeySubject.asObservable()

    open(prospectKey: string): void {
        this.openKeySubject.next(prospectKey)
    }

    close(): void {
        this.openKeySubject.next(null)
    }
}
